import { useState } from 'react';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
  DialogFooter,
} from '@/components/ui/dialog';
import { resetPassword } from '@/lib/auth';

interface ResetPasswordDialogProps {
  open: boolean;
  onClose: () => void;
  variant?: 'default' | 'hoofdhart';
}

export function ResetPasswordDialog({
  open,
  onClose,
  variant = 'default',
}: ResetPasswordDialogProps) {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState(false);

  async function handleSubmit(e: React.FormEvent<HTMLFormElement>) {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      await resetPassword(email);
      setSuccess(true);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  }

  function handleClose() {
    setEmail('');
    setError('');
    setSuccess(false);
    onClose();
  }

  return (
    <Dialog open={open} onOpenChange={handleClose}>
      <DialogContent className="sm:max-w-md">
        <DialogHeader>
          <DialogTitle>
            {success ? 'Email verzonden' : 'Wachtwoord vergeten'}
          </DialogTitle>
          <DialogDescription>
            {success
              ? 'Bedankt voor het invullen. Check je mail voor de link om je wachtwoord te resetten.'
              : 'Vul je e-mailadres in om een link te ontvangen om je wachtwoord te resetten.'}
          </DialogDescription>
        </DialogHeader>

        {!success ? (
          <form onSubmit={handleSubmit} className="space-y-4">
            <div className="space-y-2">
              <Label htmlFor="reset-email">Email</Label>
              <Input
                id="reset-email"
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="naam@voorbeeld.nl"
                required
              />
            </div>

            {error && <p className="text-sm text-red-500">{error}</p>}

            <DialogFooter>
              <Button
                type="button"
                variant="outline"
                onClick={handleClose}
                disabled={loading}
              >
                Annuleren
              </Button>
              <Button type="submit" disabled={loading} className={variant === 'hoofdhart' ? "rounded-full bg-red-700 hover:bg-red-600 text-white" : "rounded-full bg-green-800 hover:bg-green-700 text-white"}>
                {loading ? 'Laden...' : 'Versturen'}
              </Button>
            </DialogFooter>
          </form>
        ) : (
          <DialogFooter>
            <Button type="button" onClick={handleClose} className={variant === 'hoofdhart' ? "rounded-full bg-red-700 hover:bg-red-600 text-white" : "rounded-full bg-green-800 hover:bg-green-700 text-white"}>
              Sluiten
            </Button>
          </DialogFooter>
        )}
      </DialogContent>
    </Dialog>
  );
}
